import n from "react";
import { BlockTypes as m, richTextResolver as u } from "@storyblok/js";
function f(o, {
  isServerContext: t = !1
} = {}) {
  return function(e) {
    var a, l;
    const r = (a = e == null ? void 0 : e.attrs) == null ? void 0 : a.body, s = Array.isArray(r) && r.length > 0 ? r[0] : void 0, c = ((l = e.attrs) == null ? void 0 : l.id) || (t ? `fallback-key-${JSON.stringify(e.attrs)}` : void 0);
    return n.createElement(o, {
      blok: s,
      key: c
    });
  };
}
function R(o, {
  isServerContext: t = !1
} = {}) {
  return function(e) {
    const r = f(o, { isServerContext: t }), s = {
      ...t ? e : {},
      renderFn: n.createElement,
      textFn: (c) => n.createElement(n.Fragment, {
        key: Math.random().toString(36).substring(2, 15)
      }, c),
      resolvers: {
        [m.COMPONENT]: r,
        ...e.resolvers
      },
      keyedResolvers: !0,
      ...t ? {} : e
    };
    return u(s);
  };
}
export {
  f as createComponentResolver,
  R as createRichTextHook
};
